exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".messages-area{background:#f3f3f3;border:1px solid #e0e0e0;border-radius:5px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/BackupCloud.vue"],"names":[],"mappings":"AACA,eACI,mBAAmC,AACnC,yBAAyC,AACzC,iBAAmB,CACtB","file":"BackupCloud.vue","sourcesContent":["\n.messages-area {\n    background: rgba(243, 243, 243, 1);\n    border: 1px solid rgba(224, 224, 224, 1);\n    border-radius: 5px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1e015bcf","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/BackupCloud.vue
// module id = 2325
// module chunks = 23